import React from 'react'
import { Eye } from 'tabler-icons-react'
import './ExperiencePreviewBar.css'

const PreviewSelect = ({ id, label, options, value, onChange }) => (
	<label className='experience-preview-control' htmlFor={id}>
		<span>{label}</span>
		<select
			id={id}
			value={value || ''}
			onChange={(event) => onChange(event.target.value)}
			disabled={options.length === 0}
		>
			{options.length === 0 ? (
				<option value=''>None available</option>
			) : (
				options.map((option) => (
					<option key={option.id} value={option.id}>
						{option.name}
					</option>
				))
			)}
		</select>
	</label>
)

const ExperiencePreviewBar = ({
	stations = [],
	segments = [],
	selectedStationId,
	selectedSegmentId,
	onStationChange,
	onSegmentChange,
}) => (
	<header className='experience-preview-bar'>
		<div className='experience-preview-heading'>
			<Eye size={20} aria-hidden='true' />
			<div>
				<strong>Example preview</strong>
			</div>
		</div>
		<div className='experience-preview-controls'>
			<PreviewSelect
				id='experience-preview-station'
				label='Station'
				options={stations}
				value={selectedStationId}
				onChange={onStationChange}
			/>
			<PreviewSelect
				id='experience-preview-segment'
				label='Segment'
				options={segments}
				value={selectedSegmentId}
				onChange={onSegmentChange}
			/>
		</div>
	</header>
)

export default ExperiencePreviewBar
